function decodeHTMLEntities(text: string): string {
  return text
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(parseInt(dec, 10)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) =>
      String.fromCharCode(parseInt(hex, 16)),
    );
}

function normalizeQueryForSearch(query: string): string {
  return decodeHTMLEntities(query.trim()).toLowerCase();
}

export function textMatchesSearchQuery(text: string, query: string): boolean {
  const q = normalizeQueryForSearch(query);
  if (!q) return true;
  const str = decodeHTMLEntities(text);
  return str.toLowerCase().includes(q);
}

export function itemMatchesSearchQuery<T extends object>(
  item: T,
  query: string,
  fields: (keyof T)[],
): boolean {
  const q = normalizeQueryForSearch(query);
  if (!q) return true;
  return fields.some((field) => {
    const value = item[field];
    const str = decodeHTMLEntities(value == null ? '' : String(value));
    return str.toLowerCase().includes(q);
  });
}
